import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const session_id = m ? decodeURIComponent(m[1]) : null;
    if (!session_id) { navigate("/", { replace: true }); return; }

    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id });
        setUser(r.data);
        // Clean the URL hash before navigation
        window.history.replaceState({}, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user: r.data } });
      } catch (e) {
        console.error("Auth failed", e);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center aurora">
      <div className="glass rounded-2xl px-10 py-8 text-center">
        <div className="eyebrow mb-3">PerCen360</div>
        <div className="text-lg font-display">Establishing secure session…</div>
        <div className="mt-4"><span className="dot-flash"/><span className="dot-flash"/><span className="dot-flash"/></div>
      </div>
    </div>
  );
}
